<template>
  <div
    class="fixed top-0 z-[5000] flex w-full items-center gap-x-4 bg-gradient-to-r from-explorer-purple/50 to-explorer-blue/50 px-5 py-2 text-primary backdrop-blur-lg"
  >
    <span class="shrink-0">📢</span>
    <div class="flex w-full flex-1 justify-center overflow-hidden">
      <p class="notice-text">
        With the MSU mainnet launch, testnet addresses are no longer supported.
        Only addresses created after the official launch can be searched.
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">

</script>

<style scoped lang="scss">

.notice-text {
  @apply text-base text-primary whitespace-nowrap;

  @include md {
    animation: flow 40s linear infinite;
  }

  @keyframes flow {
    0% {
      transform: translateX(100vw);
    }
    98% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(-100%);
    }
  }
}
</style>